import React from "react";
import styles from "./initials-avatar.module.scss";
interface InitialsAvatarProps {
  name: string;
}

const cssClassName = "initials-avatar";

export default function InitialsAvatar({ name }: InitialsAvatarProps) {
  const getInitials = (name: string) => {
    const names = name.split(" ");
    const initials = names
      .slice(0, 2)
      .map((n) => n[0])
      .join("");
    return initials.toUpperCase();
  };

  return <div className={styles[cssClassName]}>{getInitials(name)}</div>;
}
